import { arrayOf, shape, string } from 'prop-types';
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';

class NavItemMore extends Component {
  constructor(props) {
    super(props);

    this.state = { isOpen: false };

    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
  }

  toggle() {
    this.setState(({ isOpen }) => ({ isOpen: !isOpen }));
  }

  close() {
    this.setState({ isOpen: false });
  }

  render() {
    const { items } = this.props;
    const { isOpen } = this.state;

    return (
      <Dropdown nav inNavbar isOpen={isOpen} toggle={() => this.toggle()}>
        <DropdownToggle nav caret>
          More…
        </DropdownToggle>
        <DropdownMenu right onMouseLeave={this.close}>
          {items.map(({ text, href }, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <DropdownItem tag={Link} to={href} key={index}>
              {text}
            </DropdownItem>
          ))}
        </DropdownMenu>
      </Dropdown>
    );
  }
}

NavItemMore.propTypes = {
  items: arrayOf(
    shape({ text: string.isRequired, href: string.isRequired }).isRequired,
  ).isRequired,
};

export default NavItemMore;
